// Non-active product panels (bestsellers tabs, new arrivals) ship their cards
// inside an inert <template data-panel-template>. Template content is neither
// laid out nor fetched (no <img> requests), so the homepage only pays for the
// panel that is actually visible. On first activation we stamp the template
// into its panel; callers then (re)initialise per-panel behaviour.

// Reviews.io only scans the page on load, so freshly stamped cards need a nudge
// (same approach as js/globals/inline-cart.js).
const refreshRatingWidgets = () => {
  if (typeof ratingSnippet !== "function" || typeof reviewsIoStore === "undefined") return;
  try {
    ratingSnippet("ruk_rating_snippet", {
      store: reviewsIoStore,
      color: "#f3c621",
      textClr: "#333333",
      linebreak: false,
      usePolaris: true,
      text: "Reviews",
    });
  } catch (error) {
    // A missing rating is cosmetic — never let it break the tab switch.
    console.warn("Reviews.io rating refresh skipped:", error);
  }
};

/**
 * Stamps a panel's <template data-panel-template> into the panel, if present.
 * Returns true when content was stamped (i.e. this was the panel's first use).
 * lazysizes watches the DOM via MutationObserver, so the new `.lazyload`
 * images are picked up without any extra call.
 */
const stampPanelTemplate = (panel) => {
  if (!panel) return false;

  const template = panel.querySelector(":scope > template[data-panel-template]");
  if (!template) return false;

  panel.appendChild(template.content);
  template.remove();
  refreshRatingWidgets();

  panel.dispatchEvent(new CustomEvent("bestsellers:panel-stamped", { bubbles: true }));
  return true;
};

export { stampPanelTemplate };
